import React, { useContext } from 'react';
import NotificationContext from '../../Notifications/NotificationContext';
import UIKitIcon from '../../../shared/UIKITComponents/Icon';
import { colors } from '../../../shared/theme';

const TopbarSupport: React.FC = () => {
  const { data } = useContext(NotificationContext);
  return (
    <div className="topbar__support">
      <a
        href={data.errorTicketLink}
        target="_blank"
        rel="noopener noreferrer"
        className="topbar__support__icon"
      >
        <UIKitIcon style={{ color: colors.specialColors.white }} name="build" variant="filled" />
      </a>
    </div>
  );
};

export default TopbarSupport;
